import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "contentBox" }
const _hoisted_2 = { class: "contentHolder" }

import TechnoFrame from "@/components/Common/TechnoFrame.vue";
import GameInfo from "@/components/MainPage/PcVersion/GameInfo.vue";
import ScreenshotCarousel from "@/components/MainPage/PcVersion/ScreenshotsCarousel.vue";

import { defineComponent } from 'vue'

const __default__ = defineComponent({
    name: 'GreetingsBlockContentHolder',
})


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

_useCssVars(_ctx => ({
  "4cebaa2d": (`url("/img/page/landing/main/bg/1.jpg")`)
}))


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(TechnoFrame, {
      offset: 5,
      "size-modifier": 0.3
    }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(GameInfo),
      _createVNode(ScreenshotCarousel)
    ])
  ]))
}
}

})